const mutations = {
  OPEN_POPUP (state, config) {
    Object.assign(state, { popup_visibility: true, ...config })
  },
  CLOSE_POPUP (state) {
    state.popup_visibility = false
  }
}

export default mutations
